import { useEffect } from "react";
import useHistory from "routing/useHistory";
import MimecastRoutes from "./Routes";
const MimecastInputConfiguration = () => {
  const history = useHistory();
  useEffect(() => {
    const url = MimecastRoutes.INTEGRATIONS.Mimecast.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);
  return null;
};
export default MimecastInputConfiguration;
